var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#9D9D9D",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 775 c-20 -19 -25 -34 -25 -74 l0 -49 200 -127 200 -126 198 123 197 123 3 53 c3 44 -1 56 -22 77 l-25 25 -351 0 -351 0 -24 -25z m693 -72 c-2 -9 -73 -61 -160 -115 l-158 -97 -157 98 c-87 54 -159 106 -161 115 -3 14 28 16 318 16 297 0 321 -1 318 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 380 c0 -168 0 -171 25 -195 l24 -25 351 0 351 0 24 25 c25 24 25 27 25 195 0 93 -2 170 -5 170 -3 0 -21 -10 -40 -22 l-35 -23 0 -132 0 -133 -320 0 -320 0 0 134 0 134 -36 21 c-19 12 -37 21 -40 21 -2 0 -4 -77 -4 -170z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.f541e4a0257f9683c54a91b47836b538.svg";
export { ForwardRef as ReactComponent };